import React, { useState, useEffect } from 'react';
import Grid from '@mui/material/Grid2';
import CommonCard from '../item/common_card';
import { FONT_COLOR } from '../const/general'
import { setAreaRiskLabel } from '../func/color';
import { TypographyTitle, TypographyTitleLarge } from '../style/typography'
import { BoxCenterStart } from '../style/box'

export default function MaxRiskRain(props) {
    const [riskFontColor, setRiskFontColor] = useState(props.levelPoint.LEVEL_1);
    const [risk, setRisk] = useState('通常');
    const [riskVal, setRiskVal] = useState(0);
    const [h1, setH1] = useState(0);

    // 情報を格納
    const setInfo = (risk_max) => {
        if (risk_max === null || risk_max === Number.NEGATIVE_INFINITY) {
            setRisk('-')
            setRiskVal('-')
            setRiskFontColor('white')
            return
        }
        // 文字色の設定
        setRiskFontColor(props.setColor(props.levelPoint, risk_max))
        // 表示文言の設定
        setRisk(setAreaRiskLabel(props.levelPoint, risk_max))
        setRiskVal(risk_max)
    }

    // 定期監視用
    useEffect(() => {
        if (props.h1MaxVal === null) {
            setH1('-')
            return
        }
        setH1(props.h1MaxVal)
    }, [props.h1MaxVal]);

    // 定期監視用
    useEffect(() => {
        setInfo(props.riskMaxVal)
    }, [props.riskMaxVal]);

    // 定期監視用
    useEffect(() => {
        setH1(props.h1MaxVal)
        setInfo(props.riskMaxVal)
    }, []);

    return (
        <Grid container columns={12} spacing={0} >
            {props.titleRisk !== undefined &&
                <Grid size={{ xs: 7, sm: 7, md: 7 }}>
                    <CommonCard
                        child={
                            <BoxCenterStart sx={{ flexDirection: "column", alignItems: "center" }}>
                                <TypographyTitleLarge sx={{ color: riskFontColor }}>{`${risk}`}</TypographyTitleLarge>
                                {props.riskVal && props.riskVal(riskVal, riskFontColor)}
                            </BoxCenterStart>
                        }
                        title={props.titleRisk}
                        xsHeight="60px"
                        height={props.height}
                    />
                </Grid>
            }
            {props.titleH1 !== undefined &&
                <Grid size={{ xs: 5, sm: 5, md: 5 }}>
                    <CommonCard
                        child={
                            <BoxCenterStart sx={{ flexDirection: "column", alignItems: "center" }}>
                                <TypographyTitleLarge sx={{ color: FONT_COLOR }}>{h1} </TypographyTitleLarge>
                                <TypographyTitle sx={{ color: FONT_COLOR }}>1時間雨量</TypographyTitle>
                            </BoxCenterStart>
                        }
                        title={props.titleH1}
                        xsHeight="60px"
                        height={props.height}
                    />
                </Grid>
            }
        </Grid>
    );
}